import React from "react";
import { MessageCircle } from "lucide-react";
import { SCHOOL_INFO } from "@/lib/assets";

/**
 * Floating + inline WhatsApp click-to-chat button.
 * Opens wa.me link with pre-filled message to the school's main number.
 */
export function WhatsAppButton({ message = "Bonjour, je viens du site Mazid School Connect et j'aimerais avoir des informations.", className = "", label = "WhatsApp", variant = "inline", testId = "whatsapp-btn" }) {
  const phone = SCHOOL_INFO.whatsapp.replace(/\s|\+/g, "");
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  if (variant === "floating") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        data-testid={testId}
        className={`fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center hover:scale-110 transition-transform animate-mazid-pulse ${className}`}
        aria-label="Contacter via WhatsApp"
        style={{ animationDelay: "1s" }}
      >
        <MessageCircle className="h-6 w-6" />
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#25D366] text-white font-semibold text-sm hover:bg-[#1ea952] transition-colors ${className}`}
    >
      <MessageCircle className="h-4 w-4" />
      {label}
    </a>
  );
}

export default WhatsAppButton;
